export const ACTIVITY_LOG_ACTION_LABELS: Record<string, string> = {
	production_plan_created: 'Utworzono plan produkcyjny',
	production_plan_created_manual: 'Utworzono plan produkcyjny ręcznie',
	production_meals_imported: 'Zaimportowano posiłki do planu',
	production_meals_sales_updated: 'Zaktualizowano ilości sprzedażowe',
	simulation_created: 'Utworzono symulację',
	simulation_duplicated: 'Zduplikowano symulację',
	simulation_step_changed: 'Zmieniono krok symulacji',
	simulation_meals_quantities_updated: 'Zaktualizowano ilości produkcyjne',
	simulation_auto_filled: 'Autouzupełniono symulację',
	simulation_scheduled: 'Zaplanowano produkcję',
	simulation_finalized: 'Zatwierdzono symulację',
	simulation_final_overwritten: 'Nadpisano finalną symulację',
	instructions_generated: 'Wygenerowano instrukcje',
	instructions_downloaded: 'Pobrano instrukcje',
	report_exported: 'Wyeksportowano raport',
}

export const ACTIVITY_LOG_ACTION_OPTIONS: { label: string; value: string }[] = Object.entries(
	ACTIVITY_LOG_ACTION_LABELS,
).map(([value, label]) => ({ label, value }))

export const activityLogActionLabel = (action: string) => ACTIVITY_LOG_ACTION_LABELS[action] ?? action

export const ACTIVITY_LOG_FIELD_LABELS: Record<string, string> = {
	production_plan_id: 'Plan',
	production_plan_date: 'Data planu',
	simulation_id: 'Symulacja',
	simulation_version: 'Wersja',
	source_simulation_id: 'Symulacja źr.',
	previous_simulation_id: 'Poprzednia sym.',
	previous_final_simulation_id: 'Poprz. finalna',
	cancelled_draft_simulations: 'Anulowane szkice',
	production_start_date: 'Rozpoczęcie',
	production_end_date: 'Zakończenie',
	production_duration: 'Czas trwania',
	production_meal_id: 'Posiłek',
	variant_id: 'Wariant',
	superseded: 'Nadpisano',
	dispatch_id: 'Zlecenie',
	instructions_type: 'Typ instrukcji',
	report_type: 'Typ raportu',
	file_name: 'Plik',
}

export const activityLogFieldLabel = (key: string, fallback: string) => ACTIVITY_LOG_FIELD_LABELS[key] ?? fallback

export const ACTIVITY_LOG_MINUTE_FIELDS = ['production_duration']

export const activityLogDurationLabel = (minutes: number) => {
	const hours = Math.floor(minutes / 60)
	const rest = minutes % 60

	return hours ? `${hours} h ${rest} min` : `${rest} min`
}

export const ACTIVITY_LOG_EXTRA_STEP_LABELS: Record<string, string> = {
	addons: 'Dodatki',
}

export const activityLogStepLabel = (step: string) =>
	ACTIVITY_LOG_EXTRA_STEP_LABELS[step] ?? productionStepsMap[step as EProductionSteps] ?? step
